import React, { FC } from "react";
import classNames from "classnames";
import { GatsbyImage } from "gatsby-plugin-image";
import { getGatsbyImage } from "gatsby-plugin-storyblok-image";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { Link } from "@app/components/common";
import { getYoutubeEmbedUrl } from "@app/helpers";

type Props = {
  title: string;
  image: string;
  youtubeId?: string;
};

export const Hero: FC<Props> = ({ title, image, youtubeId }) => {
  const { t } = useTranslation("t_blog");

  return (
    <div className={classNames("mb-4 flex justify-center", "md:mb-15")}>
      <div className={classNames("w-full", "md:w-10/12")}>
        <Link
          to="/blog"
          className={`text-primary-content mb-7.5 block no-underline`}
        >
          <FontAwesomeIcon icon={faChevronLeft} size="xs" width={14} />
          <span className="ml-2.5">{t("blog")}</span>
        </Link>

        {youtubeId ? (
          <div className="aspect-video">
            <iframe
              src={getYoutubeEmbedUrl(youtubeId)}
              className="h-full w-full"
              title={title}
              allowFullScreen
            />
          </div>
        ) : (
          <GatsbyImage
            image={getGatsbyImage(image, { layout: "fullWidth" })}
            alt={title}
            className="aspect-video object-cover"
          />
        )}
      </div>
    </div>
  );
};
